// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TFIT","colBig":"styles_colBig__2QyqP","colSmall":"styles_colSmall__2VaUg","shopifyNameWrapper":"styles_shopifyNameWrapper__KUNAa"};